import { weightMng } from './Initial/flow';
import { weightMngFollowup } from './followup/flow';

const WeightManagementFlows = { weightMng, weightMngFollowup };

export default WeightManagementFlows;
